export const STORAGE_KEYS = {
  USER_ACCESS_TOKEN: 'access_token',
  USER_INFO: 'user',
  ROLE_ID: 'role_id',
  FILE_LIST: 'file_list',
  TEMPLATE_ID: 'template_id',
  ACTIVATE_TOKEN: 'activate_token',
  EMAIL: 'email',
  PASSWORD: 'password',
  ENABLE_WORKFLOW_AND_METADATA: 'enable_workflow_and_metadata',
  RSA_PUBLIC_KEY: 'rsa_public_key',
  PARTNER_PERMISSIONS: 'partner_permissions',
};

export enum ROLE_ID {
  PARTNER = '1',
  TENANT = '2',
}

export enum ROLE {
  PARTNER = 1,
  TENANT = 2,
}

export enum USER_FIELDS {
  PASSWORD = 'password',
  CONFIRM_PASSWORD = 'confirmPassword',
  OLD_PASSWORD = 'oldPassword',
  NEW_PASSWORD = 'newPassword',
}

export enum ACTIVATE_FORM {
  EMAIL = 'email',
  PASSWORD = 'password',
  CONFIRM_PASSWORD = 'confirmPassword',
}

export const PARTNER_KEY = 'partner-api-key';
